import Db from './loader.js';
function writeDistIDToDixie(distId) {
    try {
        const DbConfig = (Db.configs) ? Db.configs : null;
        if (DbConfig) {

            Db.configs.where('key').equalsIgnoreCase('distIdName').delete();

            if (distId) {
                Db.configs.add({
                    key: 'distIdName',
                    value: distId
                });
            }
            console.log("ui.writeDistIDToDixie.success");
            return true;
        }

        throw new Error("ui.writeDistIDToDixie.noDbConfig");

    } catch (e) {
        console.error("ui.writeDistIDToDixie.error", e);
        return false;
    }
}

async function readDistIDFromDixie() {
    try {
        const DbConfig = (Db.configs) ? Db.configs : null;
        if (DbConfig) {
            let distIdObj = await Db.configs.where('key').equalsIgnoreCase('distIdName').first();
            if (distIdObj) {
                console.log("ui.readDistIDFromDixie.success", distIdObj.value);
                return distIdObj.value;
            } else {
                console.warn("ui.readDistIDFromDixie.noDistIdFound");
                return null;
            }
        }

        throw new Error("ui.readDistIDFromDixie.noDbConfig");

    } catch (e) {
        console.error("ui.readDistIDFromDixie.error", e);
        return null;
    }
}
export {
    readDistIDFromDixie,
    writeDistIDToDixie
}